import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function UnitFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {query, translate} = context
  const units = context.units[query.course] || []

  return (
    <ClearableSelect
      id="question-bank-unit-filter"
      className={clsx(classes.select, "unit")}
      value={query.unit || ""}
      onChange={onChange}
      caption={translate('unitName-header')}
    >
      {units.map((unit, key) => (<MenuItem value={`${context.query.course}U${unit.code}`} key={key}>{unit.name}</MenuItem>))}
    </ClearableSelect>
  )
}
